import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";
import { useApiClient } from "../../../shared/customHooks";
import { adminNotesForm } from "../../../shared/formObjects/application/adminNotesForm";
import { useApplicationContext } from "../context/applicationContext";

function AdminNotesComponent({ disabled, data }: any) {
  const api = useApiClient("AdministrativeNotes");
  const { id } = useApplicationContext();

  return (
    <BaseApplicationComponent
      formBody={adminNotesForm}
      headerLabel="Administrative Notes"
      editPath="adminNotes"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
    />
  );
}

export default AdminNotesComponent;
